// extracted by mini-css-extract-plugin
export default {"optionTitle":"QPFnA_optionTitle__TuM1Z","optionsWrapper":"QPFnA_optionsWrapper__Ym-KE","eachOption":"QPFnA_eachOption__46k7K","eachOptionSelected":"QPFnA_eachOptionSelected__vgGs-"};